import { useEffect, useState } from 'react'
import logoMobile from '../../../assets/images/logos/tech-mode-mobile-50.png';
import logoDesktop from '../../../assets/images/logos/tech-mode-desktop.png';
import { Link, useLocation } from 'react-router-dom';

export function Header() {
    const location = useLocation();
    const [isActive, setIsActive] = useState(false);
    const [route, setRoute] = useState();

    const changeButton = () => {
        setIsActive(!isActive);
    };

    const changePageMobile = () => {
        setTimeout(changeButton, 300);
    }

    const changePageHome = () => {
        if (isActive) changePageMobile();
    }

    useEffect(() => {
        const currentRoute = location.pathname.substring(1);
        setRoute(currentRoute);
    }, [location]);

    return (
        <>
            <nav className='header bg-section-primary w-100'>
                <div className='header__container container d-flex'>
                    <div className='header__box col-12 px-2 px-sm-0 d-flex justify-content-between align-items-center'>
                        <div className='header__logo'>
                            <Link className='header__logo-url' to='/' onClick={changePageHome}>
                                <img className='header__logo-mobile d-md-none' src={logoMobile} alt='Logo Tech Mode mobile' width='50' height='50' />
                                <img className='header__logo-desktop d-none d-md-block' src={logoDesktop} alt='Logo Tech Mode desktop' width='114' height='50' />
                            </Link>
                        </div>

                        <div className={`header__nav_bar ${isActive ? 'header__nav_bar--active' : ''} d-md-none`} onClick={changeButton}>
                            <div className={`header__bar header__bar1 ${isActive ? 'header__bar1--active' : ''}`}></div>
                            <div className={`header__bar header__bar2 ${isActive ? 'header__bar2--active' : ''}`}></div>
                            <div className={`header__bar header__bar3_h ${isActive ? 'header__bar3_h--active' : ''}`}></div>
                            <div className={`header__bar header__bar4 ${isActive ? 'header__bar4--active' : ''}`}></div>
                        </div>

                        {/* Items Desktop */}
                        <div className='header__links-desktop d-none d-md-block'>
                            <ul className='header__list m-0 d-flex justify-content-between'>
                                <li className='header__item px-3 py-2 px-lg-4 '>
                                    <Link className={`header__link ${route === '' ? 'header__link--active' : ''}`} to='/'>Home</Link>
                                </li>
                                <li className='header__item px-3 py-2 px-lg-4'>
                                    <Link className={`header__link header__link--disabled ${route === 'clientes' ? 'header__link--active' : ''}`} to='/clientes'>Clientes</Link>
                                </li>
                                <li className='header__item px-3 py-2 px-lg-4'>
                                    <Link className={`header__link ${route === 'nosotros' ? 'header__link--active' : ''}`} to='/nosotros'>Nosotros</Link>
                                </li>
                                <li className='header__item px-3 py-2 px-lg-4'>
                                    <Link className={`header__link ${route === 'portafolio' ? 'header__link--active' : ''}`} to='/portafolio'>Portafolio</Link>
                                </li>
                                <li className='header__item px-3 py-2 px-lg-4'>
                                    <Link className={`header__link ${route === 'contacto' ? 'header__link--active' : ''}`} to='/contacto'>Contacto</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Items Mobile */}
                <div className='header__links-mobile d-md-none'>
                    <div className={`header__links-mobile__container d-flex flex-column justify-content-between ${isActive ? 'header__links-mobile__container--active' : ''}`}>
                        <ul className='header__list container pt-5 mb-0'>
                            <li className='header__item px-2 mb-4 d-flex align-items-center'>
                                <span className={`header__item-bullet ${route === '' ? 'd-block' : 'd-none'}`}></span>
                                <Link className={`header__link ${route === '' ? 'header__link--active' : ''}`} to='/' onClick={changePageMobile}>Home</Link>
                            </li>
                            <li className='header__item px-2 mb-4 d-flex align-items-center'>
                                <span className={`header__item-bullet ${route === 'clientes' ? 'd-block' : 'd-none'}`}></span>
                                <Link className={`header__link ${route === 'clientes' ? 'header__link--active' : ''} header__link--disabled`} to='/clientes' onClick={changePageMobile}>Clientes</Link>
                            </li>
                            <li className='header__item px-2 mb-4 d-flex align-items-center'>
                                <span className={`header__item-bullet ${route === 'nosotros' ? 'd-block' : 'd-none'}`}></span>
                                <Link className={`header__link ${route === 'nosotros' ? 'header__link--active' : ''}`} to='/nosotros' onClick={changePageMobile}>Nosotros</Link>
                            </li>
                            <li className='header__item px-2 mb-4 d-flex align-items-center'>
                                <span className={`header__item-bullet ${route === 'portafolio' ? 'd-block' : 'd-none'}`}></span>
                                <Link className={`header__link ${route === 'portafolio' ? 'header__link--active' : ''}`} to='/portafolio' onClick={changePageMobile}>Portafolio</Link>
                            </li>
                            <li className='header__item px-2 mb-4 d-flex align-items-center'>
                                <span className={`header__item-bullet ${route === 'contacto' ? 'd-block' : 'd-none'}`}></span>
                                <Link className={`header__link ${route === 'contacto' ? 'header__link--active' : ''}`} to='/contacto' onClick={changePageMobile}>Contacto</Link>
                            </li>
                        </ul>
                        <div className='header__links-icon container d-flex justify-content-center align-items-center'>
                            <Link className='header__links-icon-url' to='/' onClick={changePageMobile}>
                                <img className='header__links-icon__logo' src={logoDesktop} alt='Logo Tech Mode' width='114' height='50' />
                            </Link>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
}